import React from 'react'
import styles from './AdminCommunities.module.scss'
import AppSelect from 'elements/appSelect'
import ContentDataSelector from 'containers/Workflows/ContentDataSelector/ContentDataSelector'
import { GroupService } from 'api/services/groups'
import { toast } from 'react-toastify'
import { setlocalStorageValue } from 'utils/localStorage'
import { useHistory } from 'react-router';
import ContentLoader from 'react-content-loader'

const AdminCommunities = ({ isAuthed }: { isAuthed: any }) => {
    const utm_content = process.env.REACT_APP_FREE_PLAN_UTM;

    const hideDropdownRef = React.useRef<any>(null);
    const [groups, setGroups] = React.useState<any>(null);
    const [searchString, setSearchString] = React.useState<any>('');
    const [selectedGroup, setSelectedGroup] = React.useState<any>(null);
    const history = useHistory();

    const continueInstallation = (selectedGroupID: number) => {
        if (isAuthed) {
            const getQueryParams = (): URLSearchParams => new URLSearchParams(window.location.search);
            const searchParams: any = getQueryParams();
            let params: any = {}
            for (let [key, value] of searchParams.entries()) {
                params[key] = value;
            }
            if (Object.keys(params).length > 0) {
                GroupService.getInstance()
                    .intergrationAuthorization(selectedGroupID, params.app_id, {
                        redirect: params.redirect
                    })
                    .then((response: any) => {
                        if (response) {
                            window.open(response.authorization_url, "_self");
                        }
                    })
                    .catch((error: any) => {
                        toast(" Please try again later.", {
                            type: 'error',
                            autoClose: 3000,
                            position: "top-center",
                            hideProgressBar: true,
                            theme: "light"
                        });
                        console.error(error)
                    })
                    .finally(() => { })
            }
        }
    }

    React.useEffect(() => {
        if (isAuthed) {
            GroupService.getInstance()
                .getUserAdminCommunities()
                .then((response: any) => {
                    if (response) {
                        const newList = response.data.filter((grp: any) => grp !== null).map((item: any) => {
                            return {
                                label: item.name,
                                value: item.name,
                                id: item.id,
                            }
                        });
                        setGroups(newList);
                    }
                })
                .catch((error: any) => {
                    toast(" Please try again later.", {
                        type: 'error',
                        autoClose: 3000,
                        position: "top-center",
                        hideProgressBar: true,
                        theme: "light"
                    });
                    console.error(error)
                })
                .finally(() => { })
        } else {
            let url = new URL(window.location.href)
            let pathandQuery = url.pathname + url.search;
            setlocalStorageValue("next_link", pathandQuery)
            history.push('/login')
        }

    }, [isAuthed, window.location.pathname])


    const filteredData = (searchString && searchString.trim() !== "")
        ? groups && groups.filter((item: any) =>
            item.label.toLowerCase().includes(searchString.toLowerCase())
        )
        : groups


    return (
        <div className={styles.AdminCommunities}>
            <div className={styles.AdminCommunities__container}>
                {
                    groups === null
                        ?
                        <KitInstallationLoader />
                        :
                        <>

                            <div className={styles.AdminCommunities__container__header}>
                                <h1 className={styles.AdminCommunities__container__header__h1}>Kit(Convertkit) Installation</h1>
                                {
                                    groups.length > 0 ?
                                        <p className={styles.AdminCommunities__container__header__p}>Select your community to continue installation</p>
                                        :
                                        <p className={styles.AdminCommunities__container__header__p}>Create a community to continue installation</p>

                                }
                            </div>
                            {
                                groups.length > 0 ?
                                    <AppSelect
                                        popupStyles={{ minHeight: '0px' }}
                                        inputClassName={styles.inputActionTrigger}
                                        disabled={selectedGroup}
                                        XIconstyles={selectedGroup ? styles.XIconstyles : ""}
                                        placeholder="Search or select a community"
                                        hideDropdownRef={hideDropdownRef}
                                        value={
                                            searchString &&
                                                searchString.trim() !== ''
                                                ?
                                                searchString
                                                :
                                                selectedGroup ?
                                                    (selectedGroup.label.charAt(0).toUpperCase() + selectedGroup.label.slice(1))
                                                    :
                                                    ''
                                        }
                                        markRequired
                                        cursorPointer
                                        inputIconClassName={`${styles.inputIconNameAction} ${selectedGroup ? styles.inputIconNameActionNone : ""} ${selectedGroup ? styles.hideXIconstyles : ""}`}
                                        onChangeValue={(e: any) => setSearchString(e.target.value)}
                                        onRemoveSelectedValue={() => {
                                            setSearchString('');
                                            setSelectedGroup(null);
                                        }}
                                    >
                                        {
                                            filteredData !== null ?
                                                <div className={styles.ActiontypesDropdown}>
                                                    <ContentDataSelector
                                                        data={filteredData}
                                                        onDataSelected={(value: any, data: any) => {
                                                            setSearchString('');
                                                            hideDropdownRef.current();
                                                            // continueInstallation(data.id);
                                                            setSelectedGroup({
                                                                id: data.id,
                                                                ...data
                                                            });
                                                        }}
                                                        labelStyle={styles.eventResourceTypelabelStyle}
                                                        elementContainerClass={styles.eventResourceTypelabelStyle__Dropdown}
                                                        noResultsStringStyle={styles.eventResourceTypelabelStyle__noResults}
                                                        noResultsString="No communities found"
                                                    />
                                                </div>
                                                :
                                                <></>
                                        }
                                    </AppSelect>
                                    :
                                    <></>

                            }
                            <div className={styles.AdminCommunities__container__footer}>
                                {
                                    groups.length > 0 ?
                                        <button
                                            disabled={!selectedGroup}
                                            onClick={() => {
                                                if (selectedGroup) {
                                                    continueInstallation(selectedGroup.id);
                                                }
                                            }}
                                            className={`${styles.AdminCommunities__container__footer__button} ${selectedGroup === null ? styles.AdminCommunities__container__footer__disabled : ''}`}>
                                            Continue
                                        </button>
                                        :
                                        <button
                                            onClick={() => {
                                                let url = new URL(window.location.href)
                                                // let pathandQuery = url.pathname + url.search;
                                                setlocalStorageValue("kit_installation", url.search)
                                                history.push(`/create-community?utm_content=${utm_content}`)
                                            }}
                                            className={styles.AdminCommunities__container__footer__button}>
                                            Create Community
                                        </button>
                                }
                            </div>
                        </>
                }
            </div>

        </div>
    )
}

const KitInstallationLoader = () => (
    <ContentLoader
        speed={2}
        width={420}
        height={140}
        viewBox="0 0 420 140"
    >
        {/* Title */}
        <rect x="5" y="5" rx="4" ry="4" width="260" height="16" />

        {/* Subtitle */}
        <rect x="5" y="30" rx="3" ry="3" width="300" height="12" />

        {/* Dropdown */}
        <rect x="5" y="50" rx="6" ry="6" width="400" height="30" />

        {/* Button */}
        <rect x="5" y="100" rx="6" ry="6" width="400" height="40" />
    </ContentLoader>
)
export default AdminCommunities